/* global process */
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentSpecs = require('../libs/ComponentSpecs');
var React = require('react');
var hoistNonReactStatics = require('hoist-non-react-statics');
var augmentComponent = require('./augmentComponent');
var PROPS_TO_FILTER = ['bindClickEvent', 'follow', 'followLink', 'i13nModel', 'isLeafNode', 'scanLinks'];

function objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
        if (keys.indexOf(i) >= 0) {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(obj, i)) {
            continue;
        }
        target[i] = obj[i];
    }
    return target;
}

/**
 * createI13nNode higher order function to create a Component with I13nNode functionality
 * @param {Object|String} Component the component you want to create a i13nNode
 * @param {Object} defaultProps default props
 * @param {Object} options
 * @param {String} options.displayName display name
 * @param {String} options.refToWrappedComponent ref name to wrapped component
 * @param {Boolean} options.skipUtilFunctionsByProps true to prevent i13n util function to be passed via props.i13n
 * @method createI13nNode
 */
module.exports = function createI13nNode(Component, defaultProps, options) {

    if (!Component) {
        if ('production' !== process.env.NODE_ENV) {
            console && console.warn && console.warn('You are passing a null component into createI13nNode');
            console && console.trace && console.trace();
        }
        return;
    }
    var componentName = Component.displayName || Component.name || Component;
    var componentIsFunction = 'function' === typeof Component;
    defaultProps = Object.assign({}, {
        i13nModel: null,
        isLeafNode: false,
        bindClickEvent: false,
        follow: false,
        scanLinks: null
    }, defaultProps);

    options = options || {};

    var I13nComponent = function (_React$Component) {
        _inherits(I13nComponent, _React$Component);

        function I13nComponent(props) {
            _classCallCheck(this, I13nComponent);

            return _possibleConstructorReturn(this, (I13nComponent.__proto__ || Object.getPrototypeOf(I13nComponent)).call(this, props));
        }

        _createClass(I13nComponent, [{
            key: 'render',
            value: function render() {
                // filter i13n related props
                if ('production' !== process.env.NODE_ENV && undefined !== this.props.followLink) {
                    console && console.warn && console.warn('props.followLink support is deprecated, please use props.follow instead.');
                }
                var props = objectWithoutProperties(this.props, PROPS_TO_FILTER);

                if (options.refToWrappedComponent) {
                    props.ref = options.refToWrappedComponent;
                }

                if (!props.i13n && !options.skipUtilFunctionsByProps && componentIsFunction) {
                    props.i13n = {
                        executeEvent: this.executeI13nEvent.bind(this),
                        getI13nNode: this.getI13nNode.bind(this)
                    };
                }

                return React.createElement(Component, props, props.children);
            }
        }]);

        return I13nComponent;
    }(React.Component);

    var specs = ComponentSpecs.pickSpecs();

    augmentComponent(I13nComponent, specs.prototype, Object.assign({}, specs.static, {
        displayName: options.displayName || 'I13n' + componentName,
        defaultProps: defaultProps
    }));

    if (componentIsFunction) {
        hoistNonReactStatics(I13nComponent, Component);
    }

    return I13nComponent;
};
